module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchbar":{"placeholder":"Search by email, company name, user name or employer name"}}}')
  delete Component.options._Ctor
}
